import { render, staticRenderFns } from "./VCheck.vue?vue&type=template&id=a04741f2&"
import script from "./VCheck.vue?vue&type=script&lang=js&"
export * from "./VCheck.vue?vue&type=script&lang=js&"
import style0 from "./VCheck.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports